import moment, { unitOfTime } from "moment";

export function diffNow(iso: string, unitOfTime: unitOfTime.Diff = 'days') {
	return moment().diff(moment(iso), unitOfTime);
}

export type IsBetweenDateProps = {
	from: { month: number, day: number, year?: number },
	to: { month: number, day: number, year?: number },
}

export function isBetweenDate({ from, to }: IsBetweenDateProps) {
	const date = moment();
	const year = date.year();
	const start = moment({ year, ...from }).startOf('day');
	const end = moment({ year, ...to }).endOf('day');
	return date.isBetween(start, end, null, '[]');
}
